// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-078886db]:export {\n  sideBarWidth: 210px;\n  appHeaderHeight: 60px;\n  interval: 16px;\n}\n.title span[data-v-078886db] {\n  font-size: 36px;\n  font-weight: 500;\n  color: var(--primary-text-color);\n  letter-spacing: 0;\n}\n.title .under-line[data-v-078886db] {\n  width: 56px;\n  height: 8px;\n  background: var(--primary-color);\n  margin-top: 12px;\n}\n", ""]);
// Exports
module.exports = exports;
